import { mapGetters } from 'vuex';
import commonMixin from '@/mixins/templates/common';
import { NoticeColors, NoticeColorSchemes, NoticeVisibility } from '@/helpers/notice';
import { TemplateName } from '@/helpers/templateType';
import { getHTMLPlainText } from '@/helpers/stringHelper';

export default {
  name   : 'NoticeBanner',
  mixins : [commonMixin],
  props  : {
    iconType: {
      type    : String,
      default : 'default'
    },
    title: {
      type     : String,
      required : true
    },
    content: {
      type     : String,
      required : true
    },
    colorSchema: {
      type    : String,
      default : NoticeColors.DEFAULT
    },
    isPreview: {
      type    : Boolean,
      default : false
    },
    visibility: {
      type    : Number,
      default : NoticeVisibility.VISIBLE
    },
    postedAt: {
      type    : String,
      default : ''
    }
  },
  mounted() {
    this.selectColorScheme();
    this.previewContent = getHTMLPlainText(this.content);
  },
  data() {
    return {
      TemplateName,
      NoticeVisibility,
      selectedColorSchema : null,
      previewContent      : ''
    };
  },
  watch: {
    colorSchema() {
      this.selectColorScheme();
    },
    content(newContent) {
      this.previewContent = getHTMLPlainText(newContent);
    }
  },
  computed: {
    ...mapGetters({
      getterTemplateName: 'plataforma/newContent/getterTemplateName'
    }),
    colorStyleVariables() {
      return {
        '--notice-color'      : this.selectedColorSchema?.color,
        '--notice-border'     : this.selectedColorSchema?.border,
        '--notice-background' : this.selectedColorSchema?.background
      };
    },
    themeCustomClass() {
      return [
        this.currentTheme
      ];
    },
    noticeVisibilityTooltip() {
      const postedAt = this.$options.filters.formatDateWithoutHour(this.postedAt);
      return this.visibility === NoticeVisibility.OUT_OF_PERIOD ? this.$t('noticeDetail.visibility.outOfPeriod') : this.$t('noticeDetail.visibility.scheduled', { postedAt });
    }
  },
  methods: {
    selectColorScheme() {
      this.selectedColorSchema = NoticeColorSchemes[this.getterTemplateName][this.colorSchema];
    },
    handleSeeNotice() {
      if (this.isPreview) {
        return;
      }
      this.$emit('see-notice');
    }
  }
};
